import { render, staticRenderFns } from "./IncreaseNumber.vue?vue&type=template&id=438409cd&"
import script from "./IncreaseNumber.vue?vue&type=script&lang=js&"
export * from "./IncreaseNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('438409cd')) {
      api.createRecord('438409cd', component.options)
    } else {
      api.reload('438409cd', component.options)
    }
    module.hot.accept("./IncreaseNumber.vue?vue&type=template&id=438409cd&", function () {
      api.rerender('438409cd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2wI6B5znPJXCu/JS/IncreaseNumber.vue"
export default component.exports